import { render, staticRenderFns } from "./AgencyDashboard.vue?vue&type=template&id=671e336c&"
import script from "./AgencyDashboard.vue?vue&type=script&lang=ts&"
export * from "./AgencyDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage} from 'quasar'
component.options.components = Object.assign({QPage}, component.options.components || {})
